import {
  BUILTIN_LICENSE_STATUSES,
  compareStatuses
} from '@strenforcement/domain/license';

export const STATUSES = BUILTIN_LICENSE_STATUSES;

export { compareStatuses };
